import { TouchpointType } from "types/touchpoint";

type TypedTouchpoint = {
  type?: string | null;
};

export function isTheme(obj?: any) {
  return !!obj.rootThemeId;
}

export function isEmail(obj?: TypedTouchpoint | null) {
  return !!obj && obj.type === TouchpointType.EMAIL;
}

export function isLandingPage(obj?: TypedTouchpoint | null) {
  return !!obj && obj.type === TouchpointType.LANDING_PAGE;
}

export function isLandingPageBuilderType(type?: string | null) {
  return type === TouchpointType.LANDING_PAGE || type === TouchpointType.OTHER;
}

export function usesLandingPageBuilder(obj?: TypedTouchpoint | null) {
  return isLandingPageBuilderType(obj?.type);
}
